import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, CheckCircle2 } from 'lucide-react';
export function ProductIntro() {
  return <section className="pt-20 pb-10 px-4 bg-brand-900 text-white text-center" data-id="element-269">
      <div className="max-w-4xl mx-auto" data-id="element-270">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-271">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent-500 mb-6" data-id="element-272">
            <Trophy className="w-8 h-8 text-white" data-id="element-273" />
          </div>
          <h2 className="text-3xl md:text-5xl font-black mb-4 text-white" data-id="element-274">
            MEGAPACK: NO COLAPSAR EN EL MEP™
          </h2>
          <p className="text-xl md:text-2xl text-brand-200 font-medium mb-2" data-id="element-275">
            6 Tomos + 6 Bonos — Primaria y Secundaria
          </p>
          <p className="text-lg text-brand-300" data-id="element-276">
            480+ páginas — Todo resuelto.
          </p>
        </motion.div>
      </div>
    </section>;
}
export function TomosGrid() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Escudo Administrativo',
    desc: 'Plantillas de planeamiento, asistencia, minutas, registros y comunicación con dirección. Reducí de 15 a 6 horas semanales de trabajo administrativo.'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — Protocolos de Disciplina Sin Drama',
    desc: 'Sistema escalonado de manejo de conducta. Guiones para conflictos, reportes y protocolos de respuesta. Sin gritos. Sin desgaste.'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — El Banco de Emergencia',
    desc: '50 lecciones abre y usa para primaria y secundaria. Sin preparación. Sin improvisación. Entrás al aula y ejecutás.'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Salud Mental y Desconexión Radical',
    desc: 'Protocolos de límites, desconexión digital, recuperación del burnout y sistemas de autocuidado para el docente del MEP.'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — Guía de Supervivencia en Comités',
    desc: 'Sistema completo para FEA, Bandera Azul, Gobierno Estudiantil, CEAP y todos los comités del MEP. Con plantillas de actas, informes y checklists.'
  }, {
    emoji: '📔',
    title: 'Tomo 6 — Pack de Dinámicas Energizantes',
    desc: '30 dinámicas listas para activar, calmar o reconectar cualquier grupo. Sin materiales especiales. Sin preparación previa.'
  }];
  const includes = ['Plantillas listas para usar desde el día 1', 'Protocolos paso a paso adaptados al MEP', 'Guiones de comunicación con familias e institución', 'Checklists de cumplimiento semanal', 'Versiones editables para adaptar a tu contexto', 'Evidencias y documentación para protección profesional', '100% alineado al sistema educativo costarricense'];
  return <section className="pb-20 pt-10 px-4 bg-brand-900" data-id="element-277">
      <div className="max-w-6xl mx-auto" data-id="element-278">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-279">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-xl" data-id="element-280">
              <div className="text-4xl mb-4" data-id="element-281">{tomo.emoji}</div>
              <h3 className="text-xl font-bold text-stone-900 mb-3 leading-tight" data-id="element-282">
                {tomo.title}
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-283">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-800 rounded-2xl p-8 md:p-12 border border-brand-700 max-w-4xl mx-auto" data-id="element-284">
          <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-285">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-286">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-287">
                <CheckCircle2 className="w-6 h-6 text-accent-400 flex-shrink-0" data-id="element-288" />
                <span className="text-brand-100 font-medium" data-id="element-289">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}